import React, { useState } from "react";
import axios from "axios";
import styles from "./SavePopup.module.css"; // update to your actual css module path

export default function LoadSurveyPopup({ onClose, onLogin, onLoad }) {
    const [email, setEmail] = useState("");
    const [enteredCode, setEnteredCode] = useState("");
    const [codeSent, setCodeSent] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [error, setError] = useState("");
    const [projects, setProjects] = useState([]);
    const [selectedProjectId, setSelectedProjectId] = useState(null);


      
    async function handleSendCode(e) {
        e.preventDefault();
        console.log("Sending code to:", email);
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/request-login-code`, { email });
            const data = res.data;
            console.log("📩 Email received:", email);      

        if (res.status === 200 && data.success) {
            setCodeSent(true);
            setError('');
        } else {
            setError('המייל לא נמצא במערכת.');
        }
        } catch (err) {
        console.error("Error in handleSendCode:", err);
        setError('שגיאה בשליחת קוד. נא נסו שוב.');
        }
    }

    async function handleVerifyCode(e) {
        e.preventDefault();

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/verify-code`, { email, code: enteredCode, });
            const data = res.data;
            
            if (res.status === 200 && data.success) {
                const projectsRes = await axios.get(`${process.env.REACT_APP_API_URL}/projects-by-email`, { params: { email } });
                setProjects(projectsRes.data);
                setIsLoggedIn(true);
                onLogin(email, projectsRes.data);
                setError("");
            } else {
            setError("שגיאה בטעינת פרויקטים.");
            }
        } catch (err) {
            console.error("Error in handleVerifyCode:", err);
            setError("שגיאה באימות הקוד. נא נסו שוב.");
        }
    }
    //}

  async function handleLoadProject() {
    if (!selectedProjectId) return;

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/project-data/${selectedProjectId}`);
        const data = res.data;

        if (res.status === 200 && data) {
            onLoad(data);
            onClose(); // close popup after load
        } else {
            setError("שגיאה בטעינת פרויקט.");
        }
    } catch (err) {
      console.error(err);
      setError("שגיאה בטעינת פרויקט.");
    }
  }

  return (
    <div className={styles.modalOverlay}>
        <div className={styles.modalContent}>
            <h2>טען שאלון קיים</h2>

            {!codeSent && (
            <form onSubmit={handleSendCode}>
                <label>
                כתובת מייל:
                <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    autoFocus
                />
                </label>
                {error && <p className={styles.error}>{error}</p>}
                <div className={styles.buttonRow}>
                <button type="submit">שלח קוד</button>
                <button type="button" onClick={onClose} className={styles.cancelBtn}>ביטול</button>
                </div>
            </form>
            )}

            {codeSent && !isLoggedIn && (
            <form onSubmit={handleVerifyCode}>
                <label>
                הזינו את הקוד שנשלח למייל:
                <input
                    type="text"
                    value={enteredCode}
                    onChange={e => setEnteredCode(e.target.value)}
                    required
                />
                </label>
                {error && <p className={styles.error}>{error}</p>}
                <div className={styles.buttonRow}>
                <button type="submit">כניסה</button>
                <button type="button" onClick={onClose} className={styles.cancelBtn}>ביטול</button>
                </div>
            </form>
            )}

            {isLoggedIn && (
                <div>
                    <label>
                    בחר פרויקט:
                    <select
                        value={selectedProjectId || ""}
                        onChange={e => setSelectedProjectId(e.target.value)}
                    >
                        <option value="" disabled>בחר פרויקט</option>
                        {/* check */} 
                        {projects.map((proj) => (
                            <option key={proj._id} value={proj._id}>
                                {proj.projectName}
                            </option>
                        ))}
                    </select>
                    </label>
                    {error && <p className={styles.error}>{error}</p>}
                    <div className={styles.buttonRow}>
                    <button onClick={handleLoadProject} disabled={!selectedProjectId}>טען שאלון</button>
                    <button onClick={onClose} className={styles.cancelBtn}>ביטול</button>
                    </div>
                </div>
            )}
        </div>
    </div>
  );
}